import React from 'react';

const Hero = () => {
	return (
		<section className="hero-section">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6 text-center text-lg-start">
						<img src="/assets/logo/thankwich-logo.png" alt="Thankwich Sandwich-Vorschau" className="logo img-fluid heartbeat" />
					</div>
					<div className="col-lg-6 text-center text-lg-start">
						<h1 className="display-5 fw-bold mb-3">Baue die ikonischsten Sandwiches der Welt zu Hause.</h1>
						<p className="lead mb-4">
							Thankwich hilft dir, die ikonischsten Sandwiches der Welt zu Hause zu bauen — egal ob das Reuben Sandwich aus NYC, der Bánh mì aus Vietnam oder der Katsu Sando aus Tokyo. Mit geführten Schritten und einer Gemeinschaft, die Dankbarkeit feiert. <strong>Jeder Biss sagt Danke.</strong>
						</p>
						<div className="d-flex gap-3 justify-content-center justify-content-lg-start"></div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Hero;
